export default "__VITE_ASSET__ade521ae__"